import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { Modal } from "@/components/modal";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Confirmation modal shown before permanently deleting a task. */
export function TaskDeleteConfirm(_ref) {
  var opened = _ref.opened,
    isDeleting = _ref.isDeleting,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Modal, {
    opened: opened,
    onClose: onClose,
    title: t("label.delete_task_confirm_title"),
    size: "sm",
    closeTestId: "task-detail-delete-modal-close",
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "task-detail-delete-cancel",
      intent: "base",
      variant: "secondary",
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_DELETE_CANCEL);
        onClose();
      },
      disabled: isDeleting
    }, t("button.cancel")), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "task-detail-delete-confirm",
      intent: "urgent",
      variant: "primary",
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_DELETE_CONFIRM);
        onConfirm();
      },
      loading: isDeleting
    }, isDeleting ? t("loading") : t("button.delete")))
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-base text-sds-base-secondary"
  }, t("label.delete_task_confirm_body")));
}